export default {
  Timer: '计时器',
  TimerStart: '开始计时',
  TimerPause: '暂停',
  TimerHour: '时',
  TimerMinute: '分',
  TimerSecond: '秒',
  TimerPaused: '已暂停',
  TimerResume: '继续',
  TimerReset: '重置',
  TimerEnded: '时间已到',
  TimerSetPrompt: '请设置计时时间',
  TimerRunning: '计时器已开始',
  TimerMinuteLabel: '分钟',
};
